import { render, staticRenderFns } from "./useraddModel.vue?vue&type=template&id=b58cb546&scoped=true"
import script from "./useraddModel.vue?vue&type=script&lang=js"
export * from "./useraddModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58cb546",
  null
  
)

export default component.exports